var path = '/formViewer/component/formPlaceholder.tpl.html';
var html = "<div class=\"formSectionContainer\"></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;